import { render, staticRenderFns } from "./dataAdminForm.vue?vue&type=template&id=2f061562&scoped=true"
import script from "./dataAdminForm.vue?vue&type=script&lang=js"
export * from "./dataAdminForm.vue?vue&type=script&lang=js"
import style0 from "./dataAdminForm.vue?vue&type=style&index=0&id=2f061562&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f061562",
  null
  
)

export default component.exports